import React, { createContext, useEffect, useReducer } from 'react';
import { AuthContextStateInterface } from './interfaces';
import reducerAuth from './reducer';
import {
    LOADING_ADMIN_INTRANET,
    LOADING_COMPANY_INTRANET,
    LOGIN_ADMIN,
    LOGIN_COMPANY,
    LOGOUT_ADMIN,
    LOGOUT_COMPANY,
    UPDATE_AUTH_ADMIN,
    UPDATE_AUTH_COMPANY,
    UPDATE_AUTH_TOKEN_ADMIN,
    UPDATE_AUTH_TOKEN_COMPANY
} from './types';
import {
    getAuth,
    getAuthToken,
    LOCAL_STORAGE,
    removeAuth,
    removeAuthToken,
    updateAuth as updateAuthGeneral,
    updateAuthToken as updateAuthTokenGeneral
} from '../../config';
import { Auth } from '../../app/models/Auth';

const initialState: AuthContextStateInterface = {
    authAdmin: null,
    authTokenAdmin: null,
    loggedAdmin: undefined,
    loadingAdminIntranet: true,
    authCompany: null,
    authTokenCompany: null,
    loggedCompany: undefined,
    loadingCompanyIntranet: true
};

export const AuthContext = createContext<AuthContextStateInterface>(initialState);

const AuthProvider = ({ children }: { children: React.ReactNode }) => {
    const [state, dispatch] = useReducer(reducerAuth, initialState);

    useEffect(() => {
        // Cargar autenticación de administradores
        const localStoreAuthAdmin = getAuth('admin');
        const localStoreAuthTokenAdmin = getAuthToken('admin');
        console.log(localStoreAuthAdmin);
        if (localStoreAuthAdmin && localStoreAuthTokenAdmin) {
            dispatch({
                type: LOGIN_ADMIN,
                payload: JSON.parse(localStoreAuthAdmin)
            });
        }

        // Cargar autenticación de empresas
        const localStoreAuthCompany = getAuth('company');
        const localStoreAuthTokenCompany = getAuthToken('company');
        if (localStoreAuthCompany && localStoreAuthTokenCompany) {
            dispatch({
                type: LOGIN_COMPANY,
                payload: JSON.parse(localStoreAuthCompany)
            });
        }

        dispatch({
            type: LOADING_ADMIN_INTRANET,
            payload: false
        });

        dispatch({
            type: LOADING_COMPANY_INTRANET,
            payload: false
        });
    }, []);

    const login = (auth: Auth) => {
        if (auth) {
            localStorage.setItem(LOCAL_STORAGE.AUTH_TYPE, auth.type);
            if (auth.type === 'admin') {
                localStorage.setItem(LOCAL_STORAGE.AUTH_INTRANET_ADMIN, JSON.stringify(auth));
                localStorage.setItem(LOCAL_STORAGE.AUTH_TOKEN_INTRANET_ADMIN, auth.authToken ?? '');
                dispatch({
                    type: LOGIN_ADMIN,
                    payload: auth
                });
            } else if (auth.type === 'company') {
                localStorage.setItem(LOCAL_STORAGE.AUTH_INTRANET_COMPANY, JSON.stringify(auth));
                localStorage.setItem(
                    LOCAL_STORAGE.AUTH_TOKEN_INTRANET_COMPANY,
                    auth.authToken ?? ''
                );
                dispatch({
                    type: LOGIN_COMPANY,
                    payload: auth
                });
            }
        }
    };

    const updateAuth = (auth: Auth): void => {
        if (auth.type === 'admin') {
            updateAuthGeneral(auth, auth.type);
            dispatch({
                type: UPDATE_AUTH_ADMIN,
                payload: auth
            });
        } else if (auth.type === 'company') {
            updateAuthGeneral(auth, auth.type);
            dispatch({
                type: UPDATE_AUTH_COMPANY,
                payload: auth
            });
        }
    };

    const logout = (authType: 'admin' | 'company'): void => {
        if (authType === 'admin') {
            removeAuth('admin');
            removeAuthToken('admin');
            dispatch({ type: LOGOUT_ADMIN });
            window.location.href = '/admin/login';
        } else if (authType === 'company') {
            removeAuth('company');
            removeAuthToken('company');
            dispatch({ type: LOGOUT_COMPANY });
            window.location.href = '/company/login';
        }
    };

    const updateAuthToken = (authToken: string, authType: 'admin' | 'company'): void => {
        if (authType === 'admin') {
            updateAuthTokenGeneral(authToken, 'admin');
            dispatch({
                type: UPDATE_AUTH_TOKEN_ADMIN,
                payload: authToken
            });
        } else if (authType === 'company') {
            updateAuthTokenGeneral(authToken, 'company');
            dispatch({
                type: UPDATE_AUTH_TOKEN_COMPANY,
                payload: authToken
            });
        }
    };

    return (
        <AuthContext.Provider
            value={{
                authAdmin: state.authAdmin,
                authTokenAdmin: state.authTokenAdmin,
                loggedAdmin: state.loggedAdmin,
                loadingAdminIntranet: state.loadingAdminIntranet,
                authCompany: state.authCompany,
                authTokenCompany: state.authTokenCompany,
                loggedCompany: state.loggedCompany,
                loadingCompanyIntranet: state.loadingCompanyIntranet,
                login,
                logout,
                updateAuth,
                updateAuthToken
            }}
        >
            {children}
        </AuthContext.Provider>
    );
};

export default AuthProvider;
